export default __webpack_public_path__ + "static/lut-virusi-venera-dimitrova-27d1a76c9f235de25589b2f3bcad6ab8.jpg";